import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { ViewController } from "ionic-angular";
import * as _ from "lodash";
import * as moment from "moment-timezone";
import { Subscription } from "rxjs";
import SortOptions from "../../../../models/content-wrapper/sort-options";
import { CreatinineData } from "../../../../models/creatinine/creatinine-data";
import CompanyResourceType from "../../../../models/resource-management/company-resource-type.enum";
import SelectFormInput from "../../../../models/SelectFormInput";
import { STANDING_ORDERS_CONFIG } from "../../../../pages/orders/standing-orders/standing-orders-config";
import { OrderDataService } from "../../../../providers/order-data-service/order-data-service";
import { ResourceManagementService } from "../../../../providers/resource-management/resource-management.service";
import { UtilityService } from "../../../../providers/utility-service/utility-service";
import { OrderForm } from "../order-form/order-form";

@Component({
  selector: "standing-order-form",
  templateUrl: "standing-order-form.html",
})
export class StandingOrderFormComponent
  extends OrderForm
  implements OnInit, OnDestroy
{
  checked: boolean = false;
  orderForm: FormGroup;
  orderFormData: any;
  dgMonitorAndControlPainLevel: any = FormArray;
  dgPrnChoice: any = FormArray;
  dgPatRequest: any = FormArray;
  dgDmeMedicine: any = FormArray;
  oxygenByOptions = STANDING_ORDERS_CONFIG.oxygenByOptions;
  oxygenAtOptions = STANDING_ORDERS_CONFIG.oxygenAtOptions;
  oxygenPercentages = STANDING_ORDERS_CONFIG.oxygenPercentages;
  captionAndVariables = STANDING_ORDERS_CONFIG.captionAndVariables;
  protected incomingData: any = {};
  private textAreaMaxLength: number = 500;
  private startDateMin: string = "";
  private startDateMax: string = "";
  private endDateMin: string = "";
  private endDateMax: string = "";
  frequencyOptions: any;
  dosageOptions: any;
  creatinineClearanceNeeded: boolean;
  selectedSubOrders = [];
  showActivityOrders: boolean = true;
  showDietOrders: boolean = true;
  multipleOtherOrders: boolean = true;
  firstSelectedorder: any = "";

  hidePhysiciansOptions: Boolean = true;
  searchTerm: string = "";
  selectPhysicianFlag: boolean = false;
  setPhysicianName: boolean = false;

  hideDcPhysiciansOptions: Boolean = true;
  dcSearchTerm: string = "";
  selectDcPhysicianFlag: boolean = false;
  setDcPhysicianName: boolean = false;

  private physicians: any = [];

  @Output() onValidityChange: EventEmitter<any> = new EventEmitter();
  @Input() view: boolean = false;
  @Input() templateData: any;
  @Input() addStandingOrder: boolean = false;
  @Input() physicianOptions: SelectFormInput[] = [];
  @Input() physicianOrderOptions: SelectFormInput[] = [];
  @Input() administeredByOptions: SelectFormInput[] = [];
  @Input() dosageParameterOptions: SelectFormInput[] = [];
  @Input() patientData: any;
  private creatinineData: CreatinineData;
  private creatinineSubscription$: Subscription;

  constructor(
    private formBuilder: FormBuilder,
    public viewCtrl: ViewController,
    private orderDataService: OrderDataService,
    private resourceManagementService: ResourceManagementService,
    public utilityService: UtilityService
  ) {
    super();
    this.startDateMin = moment().subtract("10", "years").format("YYYY-MM-DD");
    this.startDateMax = moment().add("10", "years").format("YYYY-MM-DD");
    this.endDateMin = moment().subtract("10", "years").format("YYYY-MM-DD");
    this.endDateMax = moment().add("10", "years").format("YYYY-MM-DD");
    this.orderFormData = {
      soVersion: ["", Validators.required],
      monitorAndControlPainLevel: [false],
      dgMonitorAndControlPainLevelGrp: this.formBuilder.group({
        dgMonitorAndControlPainLevel: this.formBuilder.array([]),
      }),
      anxietyDyspnea: [false],
      dganxietyDyspneaGrp: this.formBuilder.group({
        dganxietyDyspnea: this.formBuilder.array([]),
      }),
      otherMedication: [false],
      dgotherMedGrp: this.formBuilder.group({
        dgotherMed: this.formBuilder.array([]),
      }),
      teachPatient: [false],
      pronounceDeath: [false],
      doNotPronounceDeath: [false],
      oxygenBy: [false],
      oxygenByValue: [{ value: "", disabled: true }],
      oxygenAtValue: [{ value: "", disabled: true }],
      oxygenPercentage: [{ value: "", disabled: true }],
      oxygenByDesc: [""],
      oxygenByHsp: [false],
      oxyOpioid: [false],
      prnChoice: [false],
      dgPrnChoiceGrp: this.formBuilder.group({
        dgPrnChoice: this.formBuilder.array([]),
      }),
      isPatRequest: [false],
      dgPatRequestGrp: this.formBuilder.group({
        dgPatRequest: this.formBuilder.array([]),
      }),
      isDMEprovided: [false],
      dgDmeMedicineGrp: this.formBuilder.group({
        dgDmeMedicine: this.formBuilder.array([]),
      }),
      medicationOnMedsProfile: [false],
      asTolerated: [false],
      tubeFeeding: [false],
      typeRateSchedule: [false],
      typeRateScheduleDesc: [""],
      activityOrderHsp: [false],
      dietOrder: [""],
      supplements: [false],
      supplementsDesc: [""],
      dietOrderHsp: [false],
      completeBedRest: [false],
      upAsTolerated: [false],
      tarnsferBedChair: [false],
      ambulanceWithAssist: [false],
      nurseToEvaluate: [false],
      nurseToEvaluateDesc: [""],
      nurseToEvaluateHsp: [false],
      perosnalHygiene: [false],
      perosnalHygieneDesc: [""],
      perosnalHygieneHsp: [false],
      socialWorker: [false],
      socialWorkerDesc: [""],
      socialWorkerHsp: [false],
      spiritualNeeds: [false],
      spiritualNeedsDesc: [""],
      spiritualNeedsHsp: [false],
      volunteer: [false],
      volunteerDesc: [""],
      volunteerHsp: [false],
      other: [false],
      dgotherGrp: this.formBuilder.group({
        dgother: this.formBuilder.array([]),
      }),
      searchTerm: new FormControl(""),
      dcSearchTerm: new FormControl(""),
    };
  }

  ngOnInit() {
    if (this.addStandingOrder) {
      this.orderFormData["physician"] = [
        "",
        Validators.compose([Validators.required]),
      ];
      this.orderFormData["physicianOrder"] = [
        "",
        Validators.compose([Validators.required]),
      ];
      (this.orderFormData["physicianOrderNotes"] = [
        "",
        Validators.compose([Validators.maxLength(this.textAreaMaxLength)]),
      ]),
        (this.orderFormData["itemStartDatetime"] = [
          "",
          Validators.compose([Validators.required]),
        ]);
      this.orderFormData["administeredBy"] = [
        "",
        Validators.compose([Validators.required]),
      ];
      this.orderFormData["description"] = [""];
      this.orderFormData["itemDiscontinueDatetime"] = [""];
      this.orderFormData["teachingsPerformed"] = [""];
    }
    this.orderForm = this.formBuilder.group(this.orderFormData);

    this.orderForm.valueChanges.subscribe((data) => {
      this.onValidityChange.emit({
        validity: this.orderForm.valid && this.checkForValidation(),
        data: data,
      });
    });

    if (this.orderForm.controls["rmPhysician"]) {
      let physician: any = this.orderForm.controls["rmPhysician"];
      this.searchTerm = physician.displayName;
    }

    //enforce startDate cannot be after endDate
    if (this.orderForm.controls["itemStartDatetime"]) {
      this.orderForm.controls["itemStartDatetime"].valueChanges.subscribe(
        (data) => {
          let startDate = moment(data).format("YYYY-MM-DD");
          let endValue =
            this.orderForm.controls["itemDiscontinueDatetime"].value;

          if (endValue.length > 0) {
            let endDate = moment(endValue).format("YYYY-MM-DD");
            if (moment(startDate).isAfter(endDate)) {
              this.orderForm.controls["itemStartDatetime"].setValue("");
            }
          }

          this.endDateMin = moment(data).format("YYYY-MM-DD");
        }
      );
    }

    //enforce endDate cannot be before startDate
    if (this.orderForm.controls["itemDiscontinueDatetime"]) {
      this.orderForm.controls["itemDiscontinueDatetime"].valueChanges.subscribe(
        (data) => {
          let startValue = this.orderForm.controls["itemStartDatetime"].value;
          let endDate = moment(data).format("YYYY-MM-DD");

          if (startValue.length > 0) {
            let startDate = moment(startValue).format("YYYY-MM-DD");
            if (moment(startDate).isAfter(endDate)) {
              this.orderForm.controls["itemDiscontinueDatetime"].setValue("");
            }
          }

          this.startDateMax = moment(data).format("YYYY-MM-DD");
        }
      );
    }
    if (this.addStandingOrder) {
      this.getMedispanAdditionalParams();
    }
    if (this.view) {
      this.setTemplate();
    }
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }

  getMedispanAdditionalParams() {
    this.orderDataService.increaseSpinnerCount();
    this.creatinineSubscription$ = this.orderDataService
      .getCarryThroughCreatinineData()
      .subscribe(
        (data: CreatinineData) => {
          this.creatinineData = data;
          this.setTemplate();
        },
        (error) => {
          this.orderDataService.decreaseSpinnerCount();
        }
      );
  }

  toggleDescriptionValidation(controlName: any) {
    if (this.orderForm.controls[controlName].value) {
      this.orderForm.controls[controlName + "Desc"].setValidators([
        Validators.required,
      ]);
      if (controlName == "oxygenBy") {
        this.orderForm.controls["oxygenByValue"].enable();
        this.orderForm.controls["oxygenAtValue"].enable();
        this.orderForm.controls["oxygenPercentage"].enable();
        this.orderForm.controls["oxygenByValue"].setValidators([
          Validators.required,
        ]);
        this.orderForm.controls["oxygenAtValue"].setValidators([
          Validators.required,
        ]);
        this.orderForm.controls["oxygenPercentage"].setValidators([
          Validators.required,
        ]);
      }
    } else {
      this.orderForm.controls[controlName + "Desc"].setValidators(null);
      if (controlName == "oxygenBy") {
        this.orderForm.controls["oxygenByValue"].disable();
        this.orderForm.controls["oxygenAtValue"].disable();
        this.orderForm.controls["oxygenPercentage"].disable();
        this.orderForm.controls["oxygenByValue"].setValidators(null);
        this.orderForm.controls["oxygenAtValue"].setValidators(null);
        this.orderForm.controls["oxygenPercentage"].setValidators(null);
      }
    }

    if (controlName == "oxygenBy") {
      this.orderForm.controls["oxygenByValue"].updateValueAndValidity();
      this.orderForm.controls["oxygenAtValue"].updateValueAndValidity();
      this.orderForm.controls["oxygenPercentage"].updateValueAndValidity();
    }

    this.orderForm.controls[controlName + "Desc"].updateValueAndValidity();
  }

  hasActivitySelected() {
    let soForm = this.orderForm;
    return (
      soForm.controls["completeBedRest"].value ||
      soForm.controls["upAsTolerated"].value ||
      soForm.controls["tarnsferBedChair"].value ||
      soForm.controls["ambulanceWithAssist"].value
    );
  }

  checkForValidation() {
    let soForm = this.orderForm;
    return (
      soForm.controls["monitorAndControlPainLevel"].value ||
      soForm.controls["oxygenBy"].value ||
      soForm.controls["prnChoice"].value ||
      soForm.controls["isPatRequest"].value ||
      soForm.controls["isDMEprovided"].value ||
      soForm.controls["asTolerated"].value ||
      soForm.controls["tubeFeeding"].value ||
      soForm.controls["typeRateSchedule"].value ||
      soForm.controls["supplements"].value ||
      soForm.controls["completeBedRest"].value ||
      soForm.controls["upAsTolerated"].value ||
      soForm.controls["tarnsferBedChair"].value ||
      soForm.controls["ambulanceWithAssist"].value ||
      soForm.controls["nurseToEvaluate"].value ||
      soForm.controls["perosnalHygiene"].value ||
      soForm.controls["socialWorker"].value ||
      soForm.controls["spiritualNeeds"].value ||
      soForm.controls["volunteer"].value ||
      soForm.controls["other"].value ||
      soForm.controls["otherMedication"].value ||
      soForm.controls["anxietyDyspnea"].value
    );
  }

  setTemplate() {
    let data = this.templateData;
    let soForm = this.orderForm;
    let subOrder = data.subOrderConfig;
    soForm.controls["soVersion"].patchValue(data.versionName);
    let dietOrder = subOrder["other"]["dietOrder"];
    let activityOrder = subOrder["other"]["activityOrder"];
    let otherOrders = subOrder["other"]["otherOrders"];
    let dmeOrders = subOrder["dme"];
    this.showActivityOrders = activityOrder == null ? false : true;
    this.showDietOrders = dietOrder == null ? false : true;

    // Medication type of orders
    if (!_.isEmpty(subOrder["medication"])) {
      let medOrder = subOrder.medication;
      _.forEach(subOrder["medication"], (order) => {
        let selectedOrder = order["selectedOptions"][0];
        this.selectedSubOrders.push(selectedOrder);
        switch (selectedOrder) {
          case "monitorAndControlPainLevel": {
            this.setMultipleMedication(
              order,
              "dgMonitorAndControlPainLevelGrp",
              "dgMonitorAndControlPainLevel",
              "monitorAndControlPainLevel"
            );
            break;
          }
          case "prnChoice": {
            this.setMultipleMedication(
              order,
              "dgPrnChoiceGrp",
              "dgPrnChoice",
              "prnChoice"
            );
            break;
          }
          case "anxietyDyspnea": {
            this.setMultipleMedication(
              order,
              "dganxietyDyspneaGrp",
              "dganxietyDyspnea",
              "anxietyDyspnea"
            );
            break;
          }
          case "otherMedication": {
            this.setMultipleMedication(
              order,
              "dgotherMedGrp",
              "dgotherMed",
              "otherMedication"
            );
            break;
          }
          default:
            break;
        }
      });
    }

    if (dietOrder != null) {
      // Diet Orders
      this.selectedSubOrders.push(...dietOrder["selectedOptions"]);
      soForm.controls["typeRateScheduleDesc"].patchValue(
        dietOrder["typeRateScheduleDesc"]
      );
      soForm.controls["supplementsDesc"].patchValue(
        dietOrder["supplementsDesc"]
      );
      soForm.controls["dietOrderHsp"].patchValue(dietOrder["hospicePayer"]);
    }

    if (activityOrder != null) {
      // Activity Orders
      this.selectedSubOrders.push(...activityOrder["selectedOptions"]);
      soForm.controls["activityOrderHsp"].patchValue(
        activityOrder["hospicePayer"]
      );
    }

    _.forEach(otherOrders, (order) => {
      let option = order["selectedOptions"][0];
      if (option != "Other") {
        this.selectedSubOrders.push(option);
        soForm.controls[option + "Desc"].patchValue(order["description"]);
        soForm.controls[option + "Hsp"].patchValue(order["hospicePayer"]);
      } else {
        this.selectedSubOrders.push("other");
        let tempControl = this.populateMultipleOther(
          order["description"],
          order["hospicePayer"]
        );
        soForm.controls["dgotherGrp"]["controls"]["dgother"].push(tempControl);
      }
    });
    this.multipleOtherOrders = _.includes(this.selectedSubOrders, "other")
      ? true
      : false;

    if (!_.isEmpty(subOrder["dme"])) {
      // DME type of orders.
      _.forEach(subOrder["dme"], (order) => {
        let selectedOrder = order["selectedOptions"][0];
        this.selectedSubOrders.push(selectedOrder["option"]);
        switch (selectedOrder["option"]) {
          case "isDMEprovided": {
            let tempControl = this.populateMultiSelectControl(
              order.dmeType,
              order.hospicePayer,
              null,
              null,
              order
            );
            soForm.controls["dgDmeMedicineGrp"]["controls"][
              "dgDmeMedicine"
            ].push(tempControl);
            break;
          }
          case "isPatRequest": {
            let tempControl = this.populateMultiSelectControl(
              order.dmeType,
              order.hospicePayer,
              null,
              null,
              order
            );
            soForm.controls["dgPatRequestGrp"]["controls"]["dgPatRequest"].push(
              tempControl
            );
            break;
          }
          case "oxygenBy": {
            soForm.controls["oxygenByValue"].patchValue(
              selectedOrder["oxygenByValue"]
            );
            soForm.controls["oxygenByValue"].enable();
            soForm.controls["oxygenAtValue"].patchValue(
              selectedOrder["oxygenAtValue"]
            );
            soForm.controls["oxygenAtValue"].enable();
            soForm.controls["oxygenPercentage"].patchValue(
              selectedOrder["oxygenPercentage"]
            );
            soForm.controls["oxygenPercentage"].enable();
            soForm.controls["oxygenByDesc"].patchValue(order.dmeType);
            soForm.controls["oxygenByHsp"].patchValue(order.hospicePayer);
            break;
          }
          default:
            break;
        }
      });
    }
    for (let option of this.selectedSubOrders) {
      this.view
        ? this.orderForm.controls[option].patchValue(true)
        : this.orderForm.controls[option].patchValue(false);
    }
    soForm.updateValueAndValidity();
  }
  populateMultiSelectControl(
    text,
    isHospicePayer,
    isOpioid,
    medicineId,
    selectedOrder,
    dosageData = {},
    selectedControl = ""
  ) {
    let medObj = {
      drugText: [text, Validators.compose([Validators.required])],
      drugObject: [{ mediSpanId: medicineId }],
      searchTerm: [""],
      searchOptions: [[]],
      hideSearchOptions: [true],
      currentSearching: [false],
      isHospicePayer: [isHospicePayer],
      isOpioid: [isOpioid],
    };
    if (selectedOrder["selectedOptions"][0] == "otherMedication") {
      let desc = selectedOrder["description"].split(":")[1];
      medObj["otherDescription"] = [
        desc,
        Validators.compose([Validators.required]),
      ];
    }
    if (this.addStandingOrder && !_.isEmpty(dosageData)) {
      medObj["dosingParameters"] = [""];
      let dosageParameterOptions = dosageData["dosageParameters"].map(
        (param) => ({
          display: param,
          value: param,
        })
      );
      medObj["doseForm"] = dosageData["doseForm"]
        ? dosageData["doseForm"]
        : "N/A";
      medObj["route"] = dosageData["route"] ? dosageData["route"] : "N/A";
      medObj["strength"] = dosageData["strength"]
        ? dosageData["strength"]
        : "N/A";
      medObj["dosageParameterOptions"] = Array.of(dosageParameterOptions);
      medObj["frequencyOptions"] = [dosageData["frequency"]];
      medObj["dosageOptions"] = [dosageData["dosage"]];
      medObj["frequency"] = [""];
      medObj["dosage"] = [""];
      medObj["gpi"] = dosageData["gpi"] ? dosageData["gpi"] : "";
    }
    return this.formBuilder.group(medObj);
  }

  populateMultipleOther(desc, isHospicePayer) {
    return this.formBuilder.group({
      otherDescription: [desc, Validators.compose([Validators.required])],
      isHospicePayer: [isHospicePayer],
    });
  }

  setMultipleMedication(order, formGroup, formControl, selectedControl) {
    let medSubOrder = order.medicines;
    if (this.addStandingOrder) {
      _.forEach(medSubOrder, (suborder) => {
        this.populateDosageFields(
          false,
          suborder,
          order,
          formGroup,
          formControl,
          selectedControl
        );
      });
    } else {
      _.forEach(medSubOrder, (suborder) => {
        let tempControl = this.populateMultiSelectControl(
          suborder.name,
          suborder.hospicePayer,
          suborder.opioid,
          suborder.medicineId,
          order
        );
        this.orderForm.controls[formGroup]["controls"][formControl].push(
          tempControl
        );
      });
    }
  }

  isErrorCreatinineRelated(err) {
    let coreError = err.error.message;
    const creatinineCheck = /Creatinine/g;
    return creatinineCheck.test(coreError.message);
  }

  populateDosageFields(
    sendCreatinineClearance: boolean = false,
    suborder,
    selectedOrder,
    formGroup,
    formControl,
    selectedControl
  ) {
    if (suborder.medicineId) {
      let birthdate = this.patientData.patientChart.patientBirthdate;
      let weight = this.patientData.patientChart.currentWeightKgs;
      this.orderDataService
        .getMedicationInformation(
          suborder.medicineId,
          birthdate,
          weight,
          this.creatinineData
        )
        .subscribe(
          (data) => {
            this.orderDataService.decreaseSpinnerCount();
            let tempControl = this.populateMultiSelectControl(
              suborder.name,
              suborder.hospicePayer,
              suborder.opioid,
              suborder.medicineId,
              selectedOrder,
              data,
              selectedControl
            );
            this.orderForm.controls[formGroup]["controls"][formControl].push(
              tempControl
            );
          },
          (err) => {
            this.orderDataService.decreaseSpinnerCount();
            if (this.isErrorCreatinineRelated(err)) {
              this.creatinineClearanceNeeded = true;
              // todo: uncomment this line to go back to the old functionality.
              // this.populateDosageFields(true,suborder.medicineId, selectedOrder, formGroup, formControl,selectedControl);
            }
            let tempControl = this.populateMultiSelectControl(
              suborder.name,
              suborder.hospicePayer,
              suborder.opioid,
              suborder.medicineId,
              selectedOrder
            );
            this.orderForm.controls[formGroup]["controls"][formControl].push(
              tempControl
            );
          }
        );
    }
  }
  showOrder = (formControl) => {
    if ((this.view || this.addStandingOrder) && formControl != undefined) {
      return _.includes(this.selectedSubOrders, formControl);
    } else {
      return true;
    }
  };

  /**
   * @param searchTerm user enters to search the physician, when the term length is > 2 at that time call that getPhysicians api
   */
  searchPhysicians(searchTerm: string) {
    if (searchTerm !== "") {
      this.hidePhysiciansOptions = false;
      if (searchTerm.length > 2) {
        this.getPhysicians(searchTerm);
      }
    }
  }

  /**
   * @param searchTerm search term to get physicians
   */
  getPhysicians(searchTerm) {
    if (!this.selectPhysicianFlag) {
      this.selectPhysicianFlag = false;
      this.setPhysicianName = true;
      this.resourceManagementService
        .getCompanyResourceSummaries(
          0,
          10000,
          searchTerm,
          new SortOptions("last_name", "asc"),
          CompanyResourceType.PROVIDER
        )
        .subscribe(
          (response) => {
            this.physicians = [];
            let providers = _.filter(response.content, (x) => x.externalId); // valid external Id.
            this.physicians = this.physicians.concat(providers);
          },
          (err) => {
            this.utilityService.presentErrorToast(
              err,
              "Failed to Load Providers"
            );
          }
        );
    } else {
      this.selectPhysicianFlag = false;
    }
  }

  setPhysician(physician: any) {
    this.selectPhysicianFlag = true;
    this.setPhysicianName = false;
    this.hidePhysiciansOptions = true;
    this.orderForm.controls["physician"].setValue(physician);
    this.orderForm.controls["searchTerm"].setValue(physician.displayName);
  }
  ngOnDestroy(): void {
    if (this.addStandingOrder) {
      this.creatinineSubscription$.unsubscribe();
    }
  }
  /**
   * @param searchTerm user enters to search the physician, when the term length is > 2 at that time call that getPhysicians api
   */
  searchDcPhysicians(searchTerm: string) {
    if (searchTerm !== "") {
      this.hideDcPhysiciansOptions = false;
      if (searchTerm.length > 2) {
        this.getDcPhysicians(searchTerm);
      }
    }
  }

  /**
   * @param searchTerm search term to get physicians
   */
  getDcPhysicians(searchTerm) {
    if (!this.selectDcPhysicianFlag) {
      this.selectDcPhysicianFlag = false;
      this.setDcPhysicianName = true;
      this.resourceManagementService
        .getCompanyResourceSummaries(
          0,
          10000,
          searchTerm,
          new SortOptions("last_name", "asc"),
          CompanyResourceType.PROVIDER
        )
        .subscribe(
          (response) => {
            this.physicians = [];
            let providers = _.filter(response.content, (x) => x.externalId); // valid external Id.
            this.physicians = this.physicians.concat(providers);
          },
          (err) => {
            this.utilityService.presentErrorToast(
              err,
              "Failed to Load Providers"
            );
          }
        );
    } else {
      this.selectDcPhysicianFlag = false;
    }
  }

  setDcPhysician(physician: any) {
    this.selectDcPhysicianFlag = true;
    this.setDcPhysicianName = false;
    this.hideDcPhysiciansOptions = true;
    this.orderForm.controls["dcPhysician"].setValue(physician);
    this.orderForm.controls["dcSearchTerm"].setValue(physician.displayName);
  }
}



// WEBPACK FOOTER //
// ./src/components/orders/forms/standing-order-form/standing-order-form.ts